import { CollectionReference, collection, doc, getDoc, getFirestore } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import { SessionTypeInDatabase } from './getFirebaseSessionTypes';
import { safePromise } from './safePromise';

export const getFirebaseSessionTypesByIds = async (ids: string[]): Promise<SessionTypeInDatabase[] | undefined> => {
  if (ids.length === 0 || ids.some((id) => !id) || ids.some((id) => typeof id !== 'string')) {
    toast({
      variant: 'error',
      title: 'No Session Types found',
      description: 'Please contact support',
    });

    console.error('Provided Session Type ids are invalid', ids);

    return undefined;
  }

  const firestore = getFirestore();
  const sessionTypesRef = collection(firestore, '_sessionTypes') as CollectionReference<SessionTypeInDatabase>;

  const sessionTypesPromises = ids.map((id) => {
    return safePromise(getDoc(doc(sessionTypesRef, id)));
  });

  const sessionTypesResults = await Promise.all(sessionTypesPromises);
  const sessionTypesInDatabase: SessionTypeInDatabase[] = [];

  for (const [docSnapshot, error] of sessionTypesResults) {
    if (error) {
      toast({
        variant: 'error',
        title: 'Session Type could not be found',
        description: 'Please contact support',
      });
    } else if (docSnapshot.exists()) {
      sessionTypesInDatabase.push({
        ...docSnapshot.data(),
        id: docSnapshot.id,
      });
    }
  }

  if (sessionTypesInDatabase.length === 0) {
    toast({
      variant: 'error',
      title: 'No session types found',
      description: 'Please contact support',
    });

    return undefined;
  }

  return sessionTypesInDatabase;
};
